<template>
  <div>
       <v-snackbar :top="y === 'top'" v-model="snackbar" color="success">
      {{text}} <v-btn class="white--text" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
     <v-snackbar :top="y === 'top'" v-model="errorSnackbar" color="red">
      {{errorText}} <v-btn class="white--text" flat @click="errorSnackbar = false">X</v-btn>
    </v-snackbar>
    <div v-if="!subscribedToService">
  <v-card flat color="white">
    <v-card-text>
      <span class="grey--text subtitle font-weight-bold">
        Oops, it looks like the details for MailGun integration haven't yet been added. Please navigate to the 'Integrations' table, and add your MailGun API details.

      </span>
    </v-card-text>

  </v-card>
</div>
<div v-else>

   <v-toolbar flat color="white">
       <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab @click="templates=true;sentNotifications=false">
          Email Templates
        </v-tab>
        <v-tab @click="templates=false;sentNotifications=true">
          Sent Notifications
        </v-tab>
      </v-tabs>
      </v-toolbar>
       <v-toolbar flat color="white">
          <v-btn v-if="templates"
            round
            color="primary"
            class="white--text"
            @click=" newTemplateEditorLoaded();addTemplateModal=true, item={}, fileName='', showTemplate='', key++"
        >Add Email Template</v-btn>  
         <v-btn v-if="sentNotifications"
            round
            color="primary"
            class="white--text"
            @click="bulkMailEditorLoaded();newNotification()"
        >Send Notifications</v-btn>  
         <v-spacer></v-spacer> 
         <v-text-field
         v-if="templates"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>      
         <v-text-field
         v-if="sentNotifications"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
      </v-toolbar>
    <div v-if="templates">
     <v-data-table
        :headers="emailTemplateHeaders"
        :items="emailTemplates"
        :loading="isLoading"
        :search="search"
        item-key="id"
        :rows-per-page-items="[25, 50, 100, 250]"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-icon small class="mr-2" @click="editTemplate(props.item)">edit</v-icon>
          <v-icon small class="mr-2" @click="deleteTemplate(props.item)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.fileName}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
   
    </div>
     <div v-if="sentNotifications">
     <v-data-table
        :headers="sentHeaders"
        :items="notifications"
        item-key="id"
        :loading="isLoading"
        :search="search"
        :rows-per-page-items="[25, 50, 100, 250]"
        class="elevation-1"
      >
           <template v-slot:items="props">
        <td class="text-xs-center">{{formatDate(props.item.time)}}</td>
        <td class="text-xs-center">{{props.item.accepted.total}}</td>
        <td class="text-xs-center">{{props.item.delivered.total}}</td>
        <td class="text-xs-center">{{props.item.failed.permanent.total}}</td>
        <td class="text-xs-center">{{props.item.unsubscribed.total}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
   
    </div>


    <v-dialog persistent v-model="addTemplateModal" >
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">ADD NEW EMAIL TEMPLATE</h1>
              <v-spacer></v-spacer>
               <v-btn v-if="item.name" class="white--text" depressed round color="primary" @click="saveNewTemplate">Save</v-btn>               
               <v-btn round depressed color="primary" @click="addTemplateModal=false;"><v-icon class="white--text" >close</v-icon></v-btn>
              </v-toolbar>
              <v-card-text>
                <v-layout v-if="!item.selectTemplates" style="text-justify:center">    
                  <v-flex xs6 mx-2>
                         <v-text-field label="Save Template As" hint=".html is required" v-model="item.name"></v-text-field>    
                        </v-flex>
                  <v-flex xs6 mx-2>
                  <v-checkbox label="Select Template" v-model="item.selectTemplates"></v-checkbox>
                    </v-flex>    
                </v-layout>   
                 <v-layout v-if="item.selectTemplates" style="text-justify:center">  
                   <v-flex xs3 mx-2>
                         <v-text-field label="Save Template As" hint=".html is required" v-model="item.name"></v-text-field>    
                        </v-flex>
                  <v-flex xs3 mx-2>
                  <v-checkbox label="Select Template" v-model="item.selectTemplates"></v-checkbox>
                    </v-flex>         
                <v-flex v-if="item.selectTemplates" xs3 mx-2>
                   <v-select :items="emailTemplates" item-value="id" item-text="fileName" label="Select from Existing Templates" v-model="item.fileName"></v-select>
                </v-flex>
              <v-flex v-if="item.selectTemplates" xs3 mx-2>
                   <v-text-field persistent-hint hint=".html file is required" @click="$refs.file.click()" prepend-icon="attach_file" readonly label="Import Template" v-model="fileName"></v-text-field>
                   <input style="display: none" id="file" @change="loadTextFromFile($event)" ref="file" type="file" />
                </v-flex>           
                </v-layout>
                 <v-layout style="text-justify:center"> 
                            <div class="unlayer-editor">
      <EmailEditor :min-height="minHeight" ref="newTemplateEditor" v-on:load="newTemplateEditorLoaded" />
       </div>  
                    </v-layout>
                 <v-layout>  
                </v-layout>
              </v-card-text>
          </v-card>
      </v-dialog>

         <v-dialog persistent v-model="editTemplateModal" >
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">EDIT EMAIL TEMPLATE</h1>
              <v-spacer></v-spacer>
               <v-btn class="white--text" depressed round color="primary" @click="saveEditTemplate">Save</v-btn>               
               <v-btn round depressed color="primary" @click="editTemplateModal=false"><v-icon class="white--text" >close</v-icon></v-btn>
              </v-toolbar>
              <v-card-text>
                <v-layout v-if="!item.selectTemplates" style="text-justify:center">    
                  <v-flex xs6 mx-2>
                       <v-text-field label="Save Template As" hint=".html is required" v-model="item.name"></v-text-field>    
                   </v-flex>             
                </v-layout>
                 <v-layout style="text-justify:center">   
                      <div :key="key" class="unlayer-editor">
      <EmailEditor :min-height="minHeight" ref="editTemplateEditor"  />
       </div>  
                 </v-layout>
              </v-card-text>
          </v-card>
      </v-dialog>

       <v-dialog persistent v-model="sendMailModal" >
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">SEND BULK MAIL</h1>
              <v-spacer></v-spacer>            
               <v-btn v-if="showTemplate&&item.subject" class="white--text" depressed round color="primary" @click="checkUnsubscribe();">Next</v-btn>   
               <v-btn v-else class="white--text" round color="primary" disabled>Next</v-btn>   
               <v-btn round depressed color="primary" @click="sendMailModal=false"><v-icon class="white--text" >close</v-icon></v-btn>
              </v-toolbar>
              <v-card-text> 
                 <v-layout style="text-justify:center">      
                <v-flex xs6 mx-5>
                   <v-select :items="emailTemplates" item-value="id" item-text="fileName" label="Select Template" v-model="item.fileName"></v-select>
                </v-flex>    
                <v-spacer></v-spacer>   
                 <v-flex xs6 mx-5>
                   <v-text-field label="Email Subject" v-model="item.subject"></v-text-field>
                </v-flex>          
                </v-layout>
                 <v-layout style="text-justify:center">   
                      <div class="unlayer-editor">
      <EmailEditor :min-height="minHeight" ref="bulkMailEditor" v-on:load="bulkMailEditorLoaded" />
       </div>  
                    </v-layout>                 
              </v-card-text>
          </v-card>
      </v-dialog>

       <v-dialog persistent v-model="chooseContacts" max-width="900px" >
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">SEND BULK MAIL</h1>
              <v-spacer></v-spacer>  
               <v-btn round depressed color="primary" @click="chooseContacts=false;sendMailModal=true">Back</v-btn>
               <v-btn round depressed color="primary" @click="chooseContacts=false"><v-icon class="white--text" >close</v-icon></v-btn>
              </v-toolbar>
              <v-card-text>
                <v-layout>
                   <v-flex xs6>
               <v-checkbox v-model="allCustomers" label="Send to all ISPs"></v-checkbox>
                   </v-flex>
                <v-flex xs6>
          <v-autocomplete
            v-if="!allCustomers"
            :items="customers"
            v-model="item.customers"
            chips
            multiple
            deletable-chips
            clearable
            item-text="name"
            item-value="id"
            label="Select ISPs"
          ></v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout>
                   <v-flex xs6>
               <v-checkbox v-model="allNetworks" label="Send to all Networks"></v-checkbox>
                   </v-flex>
                <v-flex xs6>
          <v-autocomplete
            v-if="!allNetworks"
            :items="networks"
            v-model="item.networks"
            chips
            multiple
            deletable-chips
            clearable
            item-text="name"
            item-value="id"
            label="Select Networks"
          ></v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs6>
          <v-checkbox v-model="allContactTypes" label="Send to all Contact Types"></v-checkbox>
                   </v-flex>
                    <v-flex xs6>
          <v-autocomplete
            v-if="!allContactTypes"
            chips
            deletable-chips
            multiple
            clearable
            :items="contactTypes"
            item-text="name"
            item-value="id"
            v-model="item.contactTypes"
            label="Contact Types"
          ></v-autocomplete>
                    </v-flex>
                </v-layout>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              round
              color="primary"
              class="white--text"
              @click="viewContacts(item)"
            >Preview Contacts</v-btn>
            <v-btn
              round
              color="primary"
              class="white--text"
              @click="sendNotification(item)"
            >Send All Mails</v-btn>
            <v-btn
              round
              color="primary"
              class="white--text"
              @click="sendTestNotification(item)"
            >Get Test Mail</v-btn>
          </v-layout>
        </v-card-actions>
              </v-card-text>
          </v-card>
      </v-dialog>

      <v-dialog v-model="previewContactsModal" max-width="600px" persistent>
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Preview Contacts</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="previewContactsModal = false">X</v-btn>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-text-field label="Search" v-model="search" clearable></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-data-table :search="search" :items="item.allContacts" :headers="contactHeaders">
            <template v-slot:items="props">
              <td class="text-xs-center">{{props.item.contact.name}}</td>
              <td class="text-xs-center">{{props.item.contact.surname}}</td>
              <td class="text-xs-center">{{props.item.location.locationDescription}}</td>
              <td class="text-xs-center">{{props.item.location.locationNetwork.name}}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  </div>
</template>

<script>
import Api from "@/services/Api";
import { Chrome } from "vue-color";
import dateformat from "dateformat";
import { PrismEditor } from 'vue-prism-editor';
  import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere
 
  // import highlighting library (you can use any library you want just return html string)
  import { highlight, languages } from 'prismjs/components/prism-core';
  import 'prismjs/components/prism-clike';
  import 'prismjs/components/prism-javascript';
  import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles
  import { EmailEditor } from 'vue-email-editor'
export default {
  components: {
    chromepicker: Chrome,
    PrismEditor,
    EmailEditor,
  },
  data() {
    return {
      minHeight:"500px",
      pagination: {
        descending: true,
        sortBy: "time"
      },
      subscribedToService: true,
      customers:[],
      contactTypes: [],
      networks: [],
      allCustomers: true,
      allNetworks: true,
      allContactTypes: true,
      previewContactsModal: false,
       templates:false,
       sentNotifications:false,
       notifications: [],
       search:'',
       isLoading:false,
       editTemplateModal:false,
        contactType:null,
         contactHeaders: [
        {
          text: "Name",
          align: "center",
          value: "contact.name"
        },
        {
          text: "Surname",
          align: "center",
          value: "contact.surname"
        },
        {
          text: "Unit",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Network",
          align: "center",
          value: "location.locationNetwork.name"
        }
      ],
      sentHeaders: [
         {
          text: "Time Stamp",
          align: "center",
          value: "time"
        },
        {
          text: "Sent",
          align: "center",
          value: "accepted"
        },
        {
          text: "Successful",
          align: "center",
          value: "delivered"
        },
         {
          text: "Failed",
          align: "center",
          value: "failed"
        },
        {
          text: "Unsubscribed",
          align: "center",
          value: "unsubscribed"
        },
       
      ],
      contactsTable:[],
      sendMailModal:false,
      chooseContacts:false,
      key:0,
      txtName:'',
      htmlUrl: '',
      showTemplate:'//Please type html here',
      selectedId:null,
       fileRules: [
       v => !!v || '.html file is required'
      ],      
      infoArray:[],
      showPossibleFields:false,
      convertFileToHtml:'',
      fileName: '',
      keyReload: 0,
      addTemplateModal: false,
      editTemplateModal: false,
      emailTemplates:[],
      emailTypes: ["Reset Password", "Service Account Activated", "Service Account Migration", "Service Account Upgrade or Downgrade", "Inform Organisation of Application", "Inform ISP of Application", "Inform Client of Application", "Inform Organisation of Lead", "Inform Client of Lead", "Send OTP", "Notification"],
      emailTemplateHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "File Name",
          align: "center",
          value: "fileName"
        },],
      item: {},
      primaryColour: "#99cc33",
      secondaryColour: "#c2c7bd",
      contacts: [],
      navbarColour: "#7a7676",
      navbarTextColour: "#ffffff",
      newLogoUpload: false,
      noResultsError: false,
      file: "",
      snackbar: false,
      text: '',
      errorSnackbar: false,
      errorText: '',
      y: "top",
    };
  },

 async created() {
     this.subscribedToService = await this.checkSubscription()
    if(this.subscribedToService){
        this.templates=true
        this.initialize(); 
    }
   
  },
  watch:{
        "item.fileName":{
                immediate: true,
            async handler(value) {
            if(typeof(value)=='number'){
                Api().get('/organisationEmailTemplates/ById/'+ value).then(response=>{
                    this.showTemplate=response.data.emailTemplate
                   // this.showTemplate=  this.showTemplate.replace('@companyLogo', this.$store.state.currentOrg.org.logo)   
                    if(response.data.emailJson){
                      this.$refs.newTemplateEditor.loadDesign(JSON.parse(response.data.emailJson))
                      this.$refs.bulkMailEditor.loadDesign(JSON.parse(response.data.emailJson))
                    }else{
                           this.$refs.newTemplateEditor.loadDesign({"counters":
                      {"u_row":14,"u_column":18,"u_content_menu":3,"u_content_text":14,"u_content_image":4,"u_content_button":4,"u_content_social":1,"u_content_divider":6,"u_content_html":2},
                      "body":{"rows":[{"cells":[1],"columns":
                      [{"contents":[{"type":"text","values":{"containerPadding":"10px","color":"#000000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_content_text_14","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,
                      "text":response.data.emailTemplate}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_17","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideDesktop":false,"_meta":{"htmlID":"u_row_14","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}}],"values":{"backgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"500px","contentAlign":"center","fontFamily":{"label":"Montserrat","value":"'Montserrat',sans-serif","url":"https://fonts.googleapis.com/css?family=Montserrat:400,700","defaultFont":true},"preheaderText":"","linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}},"schemaVersion":5})
                     
                      this.$refs.bulkMailEditor.loadDesign({"counters":
                      {"u_row":14,"u_column":18,"u_content_menu":3,"u_content_text":14,"u_content_image":4,"u_content_button":4,"u_content_social":1,"u_content_divider":6,"u_content_html":2},
                      "body":{"rows":[{"cells":[1],"columns":
                      [{"contents":[{"type":"text","values":{"containerPadding":"10px","color":"#000000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_content_text_14","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,
                      "text":response.data.emailTemplate}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_17","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideDesktop":false,"_meta":{"htmlID":"u_row_14","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}}],"values":{"backgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"500px","contentAlign":"center","fontFamily":{"label":"Montserrat","value":"'Montserrat',sans-serif","url":"https://fonts.googleapis.com/css?family=Montserrat:400,700","defaultFont":true},"preheaderText":"","linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}},"schemaVersion":5})
                     
                    }
                })
                }
            }
        }
  },
   computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
    },
  methods: {
     async editTemplateEditorLoaded(item) {   
        if(item.emailJson){
       await this.$refs.editTemplateEditor.loadDesign(JSON.parse(item.emailJson))
       }else{
        await this.$refs.editTemplateEditor.loadDesign({
    "counters": {
        "u_row": 13,
        "u_column": 16,
        "u_content_menu": 3,
        "u_content_text": 11,
        "u_content_image": 3,
        "u_content_button": 4,
        "u_content_social": 1,
        "u_content_divider": 6
    },
    "body": {
        "rows": [],
        "values": {
            "backgroundColor": "#ffffff",
            "backgroundImage": {
                "url": "",
                "fullWidth": true,
                "repeat": false,
                "center": true,
                "cover": false
            },
            "contentAlign": "center",
            "fontFamily": {
                "label": "Montserrat",
                "value": "'Montserrat',sans-serif",
                "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                "defaultFont": true
            },
            "preheaderText": "",
            "linkStyle": {
                "body": true,
                "linkColor": "#0000ee",
                "linkHoverColor": "#0000ee",
                "linkUnderline": true,
                "linkHoverUnderline": true
            },
        }
    },
    "schemaVersion": 5
});
       }
     },
        newTemplateEditorLoaded() {       
    this.$refs.newTemplateEditor.loadDesign({
    "counters": {
        "u_row": 13,
        "u_column": 16,
        "u_content_menu": 3,
        "u_content_text": 11,
        "u_content_image": 3,
        "u_content_button": 4,
        "u_content_social": 1,
        "u_content_divider": 6
    },
    "body": {
        "rows": [],
        "values": {
            "backgroundColor": "#ffffff",
            "backgroundImage": {
                "url": "",
                "fullWidth": true,
                "repeat": false,
                "center": true,
                "cover": false
            },
            "contentAlign": "center",
            "fontFamily": {
                "label": "Montserrat",
                "value": "'Montserrat',sans-serif",
                "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                "defaultFont": true
            },
            "preheaderText": "",
            "linkStyle": {
                "body": true,
                "linkColor": "#0000ee",
                "linkHoverColor": "#0000ee",
                "linkUnderline": true,
                "linkHoverUnderline": true
            },
        }
    },
    "schemaVersion": 5
});
      },
       bulkMailEditorLoaded() {       
    this.$refs.bulkMailEditor.loadDesign({
    "counters": {
        "u_row": 13,
        "u_column": 16,
        "u_content_menu": 3,
        "u_content_text": 11,
        "u_content_image": 3,
        "u_content_button": 4,
        "u_content_social": 1,
        "u_content_divider": 6
    },
    "body": {
        "rows": [],
        "values": {
            "backgroundColor": "#ffffff",
            "backgroundImage": {
                "url": "",
                "fullWidth": true,
                "repeat": false,
                "center": true,
                "cover": false
            },
            "contentAlign": "center",
            "fontFamily": {
                "label": "Montserrat",
                "value": "'Montserrat',sans-serif",
                "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                "defaultFont": true
            },
            "preheaderText": "",
            "linkStyle": {
                "body": true,
                "linkColor": "#0000ee",
                "linkHoverColor": "#0000ee",
                "linkUnderline": true,
                "linkHoverUnderline": true
            },
        }
    },
    "schemaVersion": 5
});
      },
     highlighter(code) {
        return highlight(code, languages.js); //returns html
      },
    onChange(value) {
      console.log(value);
    },
    checkUnsubscribe(){
      if(this.showTemplate.includes('unsubscribe_url')){
          this.sendMailModal=false;
          this.chooseContacts=true 
      }else{
        let initialTemplate = this.showTemplate
        let indexBody = this.showTemplate.indexOf("</body>");
        this.showTemplate = initialTemplate.substr(0, indexBody) 
        + '<footer > <p style="color:grey; font-size:11px; text-align:center"> <a href="%unsubscribe_url%">Unsubscribe</a></p> </footer>' + initialTemplate.substr(indexBody);
          this.sendMailModal=false;
          this.chooseContacts=true 
      }

    },
      async checkSubscription(){      
      // Mass Mail now sends via Postmark (mailgunController.emailNotification),
      // so it no longer depends on a Mailgun integration record.
      return true
    },
       formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
     async getNotifications() {
       this.isLoading=true
      await Api()
        .get("/notifications/mailgun/emailNotifications")
        .then(response => {
          this.notifications = response.data.stats;
          this.isLoading=false
        });
    },
    async editTemplate(item){
       this.item = Object.assign({}, item);
       this.item.name = item.fileName
       this.showTemplate = item.emailTemplate
       if(this.item.emailJson){
       await this.$refs.editTemplateEditor.loadDesign(JSON.parse(this.item.emailJson))
       }else if(this.item.emailTemplate){
         this.$refs.editTemplateEditor.loadDesign({"counters":
                      {"u_row":14,"u_column":18,"u_content_menu":3,"u_content_text":14,"u_content_image":4,"u_content_button":4,"u_content_social":1,"u_content_divider":6,"u_content_html":2},
                      "body":{"rows":[{"cells":[1],"columns":
                      [{"contents":[{"type":"text","values":{"containerPadding":"10px","color":"#000000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_content_text_14","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,
                      "text":item.emailTemplate}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_17","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideDesktop":false,"_meta":{"htmlID":"u_row_14","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}}],"values":{"backgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"500px","contentAlign":"center","fontFamily":{"label":"Montserrat","value":"'Montserrat',sans-serif","url":"https://fonts.googleapis.com/css?family=Montserrat:400,700","defaultFont":true},"preheaderText":"","linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}},"schemaVersion":5})
                     
       }
       else{
        await this.$refs.editTemplateEditor.loadDesign({
    "counters": {
        "u_row": 13,
        "u_column": 16,
        "u_content_menu": 3,
        "u_content_text": 11,
        "u_content_image": 3,
        "u_content_button": 4,
        "u_content_social": 1,
        "u_content_divider": 6
    },
    "body": {
        "rows": [],
        "values": {
            "backgroundColor": "#ffffff",
            "backgroundImage": {
                "url": "",
                "fullWidth": true,
                "repeat": false,
                "center": true,
                "cover": false
            },
            "contentAlign": "center",
            "fontFamily": {
                "label": "Montserrat",
                "value": "'Montserrat',sans-serif",
                "url": "https://fonts.googleapis.com/css?family=Montserrat:400,700",
                "defaultFont": true
            },
            "preheaderText": "",
            "linkStyle": {
                "body": true,
                "linkColor": "#0000ee",
                "linkHoverColor": "#0000ee",
                "linkUnderline": true,
                "linkHoverUnderline": true
            },
        }
    },
    "schemaVersion": 5
});
       }
       this.editTemplateModal=true
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    fetchEmailTemplates(){
      this.isLoading=true
          Api()
        .get("/organisationEmailTemplates/byType/Notification")
        .then(response => {                    
          this.emailTemplates = response.data
          this.isLoading=false
        })
    },
      deleteTemplate(item){
        if(this.authDelete(this.$store.state.currentRoute)){
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/organisationEmailTemplates/" + item.id, {
          isActive: false,
          isDeleted: true
        }).then(response=>
        {this.fetchEmailTemplates(item.type)
        })
      }        
        },
         validate(){            
           if((this.item.fileName != null && this.item.fileName != '')&&(this.item.type != null && this.item.type != '') )
                              {
                                      return true
                              }
        },
        saveEditTemplate(){
            this.$refs.editTemplateEditor.exportHtml(
          (data) => {
            Api()
            .put('/organisationEmailTemplates/'+ this.item.id,{
                fileName: this.item.name,
                emailTemplate: data.html,
                emailJson: JSON.stringify(data.design),
                organisationId: this.$store.state.currentOrg.org.id,
                isActive: true,
                isDelete: false
            }).then(response=>{
                 this.editTemplateModal=false, 
                 this.key++
                 this.fetchEmailTemplates()    
            }) 
          })
        },
        saveNewTemplate(){
           this.$refs.newTemplateEditor.exportHtml(
          (data) => {
            Api()
            .post('/organisationEmailTemplates',{
                fileName: this.item.name,
                type: "Notification",
                emailTemplate: data.html,
                emailJson: JSON.stringify(data.design),
                organisationId: this.$store.state.currentOrg.org.id,
                isSelected: true,
                isActive: true,
                isDelete: false
            }).then(response=>{
                 this.addTemplateModal=false, 
                 this.fetchEmailTemplates()    
            }) 
          })
        },
    async loadTextFromFile(event){
      var file = event.target.files[0];   
        if(file.name.includes(".html")){   
         var reader = await new FileReader();    
          reader.onload = () => {     
          this.setResultHtml(reader.result)
      }
       await reader.readAsText(event.target.files[0]);
     reader.onerror = function() {
        console.log('there are some problems');
    };    
       // this.item.fileName = file.name
        this.fileName = file.name
        }else{
          this.fileName=''
        }    
    },
    setResultHtml(result){
     this.item.emailTemplate=result   
     this.showTemplate = result 
         this.$refs.newTemplateEditor.loadDesign({"counters":
                      {"u_row":14,"u_column":18,"u_content_menu":3,"u_content_text":14,"u_content_image":4,"u_content_button":4,"u_content_social":1,"u_content_divider":6,"u_content_html":2},
                      "body":{"rows":[{"cells":[1],"columns":
                      [{"contents":[{"type":"text","values":{"containerPadding":"10px","color":"#000000","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_content_text_14","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,
                      "text":result}}],"values":{"backgroundColor":"","padding":"0px","border":{},"_meta":{"htmlID":"u_column_17","htmlClassNames":"u_column"}}}],"values":{"displayCondition":null,"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"padding":"0px","hideDesktop":false,"_meta":{"htmlID":"u_row_14","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true}}],"values":{"backgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":false,"center":true,"cover":false},"contentWidth":"500px","contentAlign":"center","fontFamily":{"label":"Montserrat","value":"'Montserrat',sans-serif","url":"https://fonts.googleapis.com/css?family=Montserrat:400,700","defaultFont":true},"preheaderText":"","linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}},"schemaVersion":5})
                     
    },
     setResultUrl(result){
     this.item.htmlUrl=result    
    },
    async fetchUrl(html, fileName){
      var text = html
      var data = new Blob([text], {type: 'text/plain'});
      var url = window.URL.createObjectURL(data);
      this.htmlUrl= url;
      this.txtName = fileName.replace(fileName.substring(fileName.length-5), ".txt")
    },    
        fetchContactTypes() {
      Api()
        .get("/contactTypes")
        .then(response => {
          this.contactTypes = response.data;
        });
    },
       fetchCustomers() {
      Api()
        .get("/customer/organisation/basic/providers")
        .then(response => {
          this.customers = response.data;
        });
    },
     async getNetworks() {
      await Api()
        .get("/locationNetworks/simple/active")
        .then(response => {
          this.networks = response.data;
        });
    },
      async viewContacts(item) {
      this.item.allContacts = await this.previewContacts(item);
      this.previewContactsModal = true;
    },
    async sendNotification(item) {
      this.item.allContacts = await this.previewContacts(item);
      this.item.emailAddressArray = await this.item.allContacts.map(x=> x.contact.emailAddress)
      // this.item.emailTemplate = this.showTemplate
       this.$refs.bulkMailEditor.exportHtml(
         async (data) => {
          this.item.emailTemplate= data.html
           await this.createNotification(this.item);
    })
     
    },

    async sendTestNotification(){
     this.item.emailAddressArray = [this.$store.state.user.emailAddress]
     //this.item.emailTemplate = this.showTemplate
     this.$refs.bulkMailEditor.exportHtml(
        async (data) => {
          this.item.emailTemplate= data.html
     await Api()
          .post("/notifications/mailgun/createEmailNotification", this.item)
          .then(response => {
            if(response.data){
              this.snackbar = true
              this.text = "Successfully sent out your test notification!"
            } else {
              this.errorSnackbar = true
              this.errorText = "You have no devices subscribed to this service."
            }
          })
         })
    },
    async createNotification(item) {
      confirm("Are you sure you want to send out this notification?") &&
        (await Api()
          .post("/notifications/mailgun/createEmailNotification", item)
          .then(response => {
            if(response.data){
               this.snackbar = true
              this.text = "Successfully sent out notifications."
            } else {
              this.errorSnackbar = true
              this.errorText = "None of the selected contacts are subscribed to notifications."
            }
            this.getNotifications();
            this.allContactTypes = true;
            this.allNetworks = true;
            this.newNotificationModal = false;
            this.item = {};
          }));
    },
    async previewContacts(item) {
      let contacts = [];
      if (this.allContactTypes) {
        this.item.contactTypes = this.contactTypes.map(x => x.id);
      }
      if (this.allNetworks) {
        this.item.networks = this.networks.map(x => x.id);
      }
      if (this.allCustomers) {
        this.item.customers = this.customers.map(x => x.id);
      }
      await Api()
        .post("/locationContacts/bulkEmailNotification", item)
        .then(response => {
          this.item.emailAddressArray= response.data.map(x => x.contact.emailAddress);
          contacts = response.data;
        });
      return contacts;
    },
    newNotification() {
      if(this.authCreate(this.$store.state.currentRoute)){
      this.item = {
        title: "",
        message: "",
        networks: [],
        contacts: [],
        customers:[],
        contactTypes: []
      };
      this.showTemplate=''
      this.sendMailModal = true;
      }
    },
    initialize() {     
      this.fetchEmailTemplates()
      this.getNotifications()
      this.getNetworks();
      this.fetchContactTypes();
      this.fetchCustomers()
    },
  }
};
</script>
<style>
  /* required class */
  .my-editor {
    /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
    background: #fff;
    color: rgb(185, 185, 185);
 
    /* you must provide font-family font-size line-height. Example: */
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
  }
 
  /* optional class for removing the outline */
  .prism-editor__textarea:focus {
    outline: none;
  }
  .unlayer-editor {
  flex: 1;
  display: flex;
}
</style> 